// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['/util/util.js'], zutil=>{

const E = {};

const url = u=>'/use-cases/'+u;

E.list = Object.entries({
    data_extraction: {
        title: 'Data Extraction',
        url: url('web-data-extraction'),
        desc: `Whether you're looking for pricing intelligence, scanning
        public/legal records or looking towards social media for actionable
        trends, we help you collect accurate data and achieve your business
        goals`,
    },
    price_comparison: {
        title: 'Price Comparison',
        url: url('price-comparison'),
        desc: `Aggregate and compare prices so you can outprice your
        competition!`,
    },
    ad_verification: {
        title: 'Ad Verification',
        url: url('ad-verification'),
        desc: `Verify advertisement compliance and ensure your ads are reaching
        the audiences you intended!`,
    },
    ecomm: {
        title: 'eCommerce',
        url: url('ecommerce'),
        desc: `Collect competitive intelligence on pricing and inventory`,
    },
    travel: {
        title: 'Travel Aggregation',
        url: url('travel-aggregation'),
        desc: `Retrieve competitor's pricing, destination, and carrier
        offering so that you can stay ahead of the game`,
    },
    brand_protection: {
        title: 'Brand protection',
        url: url('brand-protection'),
        desc: `Protect your brand and online assets against brand abuse,
        intellectual copyright infringements, hostile domain creation, and
        domain cloning`,
    },
    seo: {
        title: 'SEO',
        url: url('seo-monitoring'),
        desc: `Allows you to do everything from rank tracking to checking the
        mobile-first search engine index helping you improve SEO outcomes`,
    },
    market_research: {
        title: 'Market Research',
        url: url('market-research'),
        desc: `Allows you to accurately analyze competitor as well as
        consumer data across international markets`,
    },
    serp: {
        title: 'SERP',
        url: url('serp'),
        desc: `Monitor search engine result pages from Google, Bing and
        Yahoo so that you can rank first`,
    },
    website_testing: {
        title: 'Website Testing',
        url: url('website-testing'),
        desc: `Test your website's functionality and performance so that you
        can optimize for a better user experience`,
    },
    fintech: {
        title: 'Fintech',
        url: url('fintech'),
        desc: `Aggregate reliable, near real-time financial investment data so
        that you can make more informed decisions`,
    },
    cyber_security: {
        title: 'Cyber security',
        url: url('security-management'),
        desc: `Conduct deep analyses with unlimited parameters so that you
        can keep your assets safe against the next threat`,
    },
    account_management: {
        title: 'Account Management',
        url: url('social_account_management_proxies'),
        desc: `Handle any size operation allowing you to maintain multiple
            accounts across various platforms`,
    },
    ngo: {
        title: 'NGOs',
        url: url('ngo'),
        desc: `The trusted and verified proxy solution for aggregating the most
            reliable data available`,
    },
}).map(e=>({id: e[0], ...e[1]}));

E.list.by_id = zutil.reduce_obj(E.list, 'id', v=>v);

return E; }); // eslint-disable-line
